import {
  LabelString
} from "./chunk-3AS7NXWQ.js";
import {
  LabelModerateString
} from "./chunk-2Y4B6XYK.js";
import {
  LabelStrongString
} from "./chunk-7XBITPVC.js";
import {
  OverlineString
} from "./chunk-L3UM7PQ4.js";
import {
  BodyStrongString
} from "./chunk-TBGADBO7.js";
import {
  DisplayString
} from "./chunk-RUM5LV7O.js";
import {
  TitleString
} from "./chunk-IVEDTGKR.js";
import {
  CodeString
} from "./chunk-BFKS4XGF.js";
import {
  BodyString
} from "./chunk-RKWGY5RW.js";
import {
  HeadlineString
} from "./chunk-2YWWFRRD.js";

// src/components/typography/renderTypography.tsx
import React from "react";
var typographyMap = {
  Display: DisplayString,
  Headline: HeadlineString,
  Title: TitleString,
  Body: BodyString,
  "Body Strong": BodyStrongString,
  Label: LabelString,
  "Label Moderate": LabelModerateString,
  "Label Strong": LabelStrongString,
  Overline: OverlineString,
  Code: CodeString,
  "Code Strong": CodeString
};
var renderTypography = (typographyType, typographyProps) => {
  const TypographyComponent = typographyMap[typographyType];
  const { children } = typographyProps;
  return React.createElement(TypographyComponent, typographyProps, children);
};

export {
  typographyMap,
  renderTypography
};
